export const GET_DECKS = 'GET_DECKS';
export const SET_DECKS = 'SET_DECKS';
